'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _downshift = require('downshift');

var _downshift2 = _interopRequireDefault(_downshift);

var _emotionTheming = require('emotion-theming');

var _actions = require('@appbaseio/reactivecore/lib/actions');

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _helper = require('@appbaseio/reactivecore/lib/utils/helper');

var _types = require('@appbaseio/reactivecore/lib/utils/types');

var _types2 = _interopRequireDefault(_types);

var _suggestions = require('@appbaseio/reactivecore/lib/utils/suggestions');

var _suggestions2 = _interopRequireDefault(_suggestions);

var _causes = require('@appbaseio/reactivecore/lib/utils/causes');

var _causes2 = _interopRequireDefault(_causes);

var _Title = require('../../styles/Title');

var _Title2 = _interopRequireDefault(_Title);

var _Input = require('../../styles/Input');

var _Input2 = _interopRequireDefault(_Input);

var _SearchSvg = require('../shared/SearchSvg');

var _SearchSvg2 = _interopRequireDefault(_SearchSvg);

var _CancelSvg = require('../shared/CancelSvg');

var _CancelSvg2 = _interopRequireDefault(_CancelSvg);

var _InputIcon = require('../../styles/InputIcon');

var _InputIcon2 = _interopRequireDefault(_InputIcon);

var _Container = require('../../styles/Container');

var _Container2 = _interopRequireDefault(_Container);

var _utils = require('../../utils');

var _SuggestionItem = require('./addons/SuggestionItem');

var _SuggestionItem2 = _interopRequireDefault(_SuggestionItem);

var _SuggestionWrapper = require('./addons/SuggestionWrapper');

var _SuggestionWrapper2 = _interopRequireDefault(_SuggestionWrapper);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DataSearch = function (_Component) {
  _inherits(DataSearch, _Component);

  function DataSearch(props) {
    _classCallCheck(this, DataSearch);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    var currentValue = props.selectedValue || props.value || props.defaultValue || '';
    _this.state = {
      currentValue: currentValue,
      suggestions: [],
      isOpen: false
    };
    _this.internalComponent = props.componentId + '__internal';
    _this.locked = false;
    _this.queryOptions = {
      size: 20
    };
    props.addComponent(props.componentId);
    props.addComponent(_this.internalComponent);
    props.setQueryListener(props.componentId, props.onQueryChange, props.onError);

    if (props.highlight) {
      var queryOptions = DataSearch.highlightQuery(props) || {};
      queryOptions.size = 20;
      _this.queryOptions = queryOptions;
      props.setQueryOptions(props.componentId, queryOptions);
    } else {
      props.setQueryOptions(props.componentId, _this.queryOptions);
    }

    _this.setReact(props);

    var hasMounted = false;
    var cause = null;

    if (currentValue) {
      _this.setValue(currentValue, true, props, cause, hasMounted);
    }

    return _this;
  }

  DataSearch.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    (0, _helper.checkSomePropChange)(this.props, prevProps, ['highlight', 'dataField', 'highlightField'], function () {
      var queryOptions = DataSearch.highlightQuery(_this2.props) || {};
      queryOptions.size = 20;
      _this2.queryOptions = queryOptions;

      _this2.props.setQueryOptions(_this2.props.componentId, queryOptions);
    });
    (0, _helper.checkPropChange)(this.props.react, prevProps.react, function () {
      return _this2.setReact(_this2.props);
    });

    if (Array.isArray(this.props.suggestions) && this.state.currentValue.trim().length) {
      // shallow check allows us to set suggestions even if the next set
      // of suggestions are same as the current one
      if (this.props.suggestions !== prevProps.suggestions) {
        if (this.props.onSuggestions) {
          this.props.onSuggestions(this.props.suggestions);
        } // eslint-disable-next-line


        this.setState({
          suggestions: this.onSuggestions(this.props.suggestions)
        });
      }
    }

    (0, _helper.checkSomePropChange)(this.props, prevProps, ['fieldWeights', 'fuzziness', 'queryFormat', 'dataField', 'nestedField'], function () {
      _this2.updateQuery(_this2.props.componentId, _this2.state.currentValue, _this2.props);
    });

    if (this.props.value !== prevProps.value) {
      this.setValue(this.props.value, true, this.props);
    } else if ( // since, selectedValue will be updated when currentValue changes,
    // we must only check for the changes introduced by
    // clear action from SelectedFilters component in which case,
    // the currentValue will never match the updated selectedValue
    this.props.selectedValue !== prevProps.selectedValue && this.state.currentValue !== this.props.selectedValue) {
      var _props = this.props,
          value = _props.value,
          onChange = _props.onChange;

      if (value === undefined) {
        this.setValue(this.props.selectedValue || '', true, this.props);
      } else if (onChange) {
        // value prop exists
        onChange(this.props.selectedValue || '');
      } else {
        // value prop exists and onChange is not defined:
        // we need to put the current value back into the store
        // if the clear action was triggered by interacting with
        // selected-filters component
        this.setValue(this.state.currentValue, true, this.props);
      }
    }
  };

  DataSearch.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.removeComponent(this.props.componentId);
    this.props.removeComponent(this.internalComponent);
  };

  DataSearch.prototype.render = function render() {
    var _this3 = this;

    var currentValue = this.state.currentValue;
    var suggestionsList = [];

    if (!this.state.currentValue && this.props.defaultSuggestions && this.props.defaultSuggestions.length) {
      suggestionsList = this.props.defaultSuggestions;
    } else if (this.state.currentValue) {
      suggestionsList = this.state.suggestions;
    }

    var _props2 = this.props,
        theme = _props2.theme,
        themePreset = _props2.themePreset,
        renderAllSuggestions = _props2.renderAllSuggestions;
    return _react2.default.createElement(_Container2.default, {
      style: this.props.style,
      className: this.props.className
    }, this.props.title && _react2.default.createElement(_Title2.default, {
      className: (0, _helper.getClassName)(this.props.innerClass, 'title') || null
    }, this.props.title), this.props.defaultSuggestions || this.props.autosuggest ? _react2.default.createElement(_downshift2.default, _extends({
      id: this.props.componentId + '-downshift',
      onChange: this.onSuggestionSelected,
      onStateChange: this.handleStateChange,
      isOpen: this.state.isOpen,
      itemToString: function itemToString(i) {
        return i;
      },
      render: function render(_ref) {
        var getInputProps = _ref.getInputProps,
            getItemProps = _ref.getItemProps,
            isOpen = _ref.isOpen,
            highlightedIndex = _ref.highlightedIndex;
        return _react2.default.createElement('div', {
          className: _Input.suggestionsContainer
        }, _react2.default.createElement(_Input2.default, _extends({
          id: _this3.props.componentId + '-input',
          showIcon: _this3.props.showIcon,
          showClear: _this3.props.showClear,
          iconPosition: _this3.props.iconPosition,
          innerRef: function innerRef(c) {
            _this3._inputRef = c;
          }
        }, getInputProps({
          className: (0, _helper.getClassName)(_this3.props.innerClass, 'input'),
          placeholder: _this3.props.placeholder,
          value: _this3.state.currentValue === null ? '' : _this3.state.currentValue,
          onChange: _this3.onInputChange,
          onBlur: _this3.props.onBlur,
          onFocus: _this3.handleFocus,
          onKeyPress: _this3.props.onKeyPress,
          onKeyDown: function onKeyDown(e) {
            return _this3.handleKeyDown(e, highlightedIndex);
          },
          onKeyUp: _this3.props.onKeyUp
        }), {
          themePreset: themePreset
        })), _this3.renderIcons(), renderAllSuggestions && renderAllSuggestions({
          currentValue: _this3.state.currentValue,
          isOpen: isOpen,
          getItemProps: getItemProps,
          highlightedIndex: highlightedIndex,
          suggestions: _this3.props.suggestions,
          parsedSuggestions: suggestionsList
        }), _this3.renderLoader(), _this3.renderError(), !renderAllSuggestions && isOpen && suggestionsList.length ? _react2.default.createElement('ul', {
          className: (0, _Input.suggestions)(themePreset, theme) + ' ' + (0, _helper.getClassName)(_this3.props.innerClass, 'list')
        }, suggestionsList.slice(0, 10).map(function (item, index) {
          return _react2.default.createElement('li', _extends({}, getItemProps({
            item: item
          }), {
            key: index + 1 + '-' + item.value,
            style: {
              backgroundColor: _this3.getBackgroundColor(highlightedIndex, index)
            }
          }), _react2.default.createElement(_SuggestionItem2.default, {
            currentValue: currentValue,
            suggestion: item
          }));
        })) : _this3.renderNoSuggestion(suggestionsList));
      }
    }, this.props.downShiftProps)) : _react2.default.createElement('div', {
      className: _Input.suggestionsContainer
    }, _react2.default.createElement(_Input2.default, {
      className: (0, _helper.getClassName)(this.props.innerClass, 'input') || null,
      placeholder: this.props.placeholder,
      value: this.state.currentValue ? this.state.currentValue : '',
      onChange: this.onInputChange,
      onBlur: this.props.onBlur,
      onFocus: this.props.onFocus,
      onKeyPress: this.props.onKeyPress,
      onKeyDown: this.props.onKeyDown,
      onKeyUp: this.props.onKeyUp,
      autoFocus: this.props.autoFocus,
      iconPosition: this.props.iconPosition,
      showIcon: this.props.showIcon,
      showClear: this.props.showClear,
      themePreset: themePreset
    }), this.renderIcons()));
  };

  return DataSearch;
}(_react.Component);

DataSearch.highlightQuery = function (props) {
  if (props.customHighlight) {
    return props.customHighlight(props);
  }

  if (!props.highlight) {
    return null;
  }

  var fields = {};
  var highlightField = props.highlightField ? props.highlightField : props.dataField;

  if (typeof highlightField === 'string') {
    fields[highlightField] = {};
  } else if (Array.isArray(highlightField)) {
    highlightField.forEach(function (item) {
      fields[item] = {};
    });
  }

  return {
    highlight: {
      pre_tags: ['<mark>'],
      post_tags: ['</mark>'],
      fields: fields
    }
  };
};

DataSearch.defaultQuery = function (value, props) {
  var finalQuery = null;
  var fields = void 0;

  if (value) {
    if (Array.isArray(props.dataField)) {
      fields = props.dataField;
    } else {
      fields = [props.dataField];
    }

    finalQuery = {
      bool: {
        should: DataSearch.shouldQuery(value, fields, props),
        minimum_should_match: '1'
      }
    };
  }

  if (value === '') {
    finalQuery = {
      match_all: {}
    };
  }

  if (finalQuery && props.nestedField) {
    finalQuery = {
      nested: {
        path: props.nestedField,
        query: finalQuery
      }
    };
  }

  return finalQuery;
};

DataSearch.shouldQuery = function (value, dataFields, props) {
  var fields = dataFields.map(function (field, index) {
    return '' + field + (Array.isArray(props.fieldWeights) && props.fieldWeights[index] ? '^' + props.fieldWeights[index] : '');
  });

  if (props.queryFormat === 'and') {
    return [{
      multi_match: {
        query: value,
        fields: fields,
        type: 'cross_fields',
        operator: 'and'
      }
    }, {
      multi_match: {
        query: value,
        fields: fields,
        type: 'phrase_prefix',
        operator: 'and'
      }
    }];
  }

  return [{
    multi_match: {
      query: value,
      fields: fields,
      type: 'best_fields',
      operator: 'or',
      fuzziness: props.fuzziness ? props.fuzziness : 0
    }
  }, {
    multi_match: {
      query: value,
      fields: fields,
      type: 'phrase_prefix',
      operator: 'or'
    }
  }];
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setReact = function (props) {
    var react = props.react;

    if (react) {
      var newReact = (0, _helper.pushToAndClause)(react, _this4.internalComponent);
      props.watchComponent(props.componentId, newReact);
    } else {
      props.watchComponent(props.componentId, {
        and: _this4.internalComponent
      });
    }
  };

  this.onSuggestions = function (results) {
    var renderSuggestion = _this4.props.renderSuggestion;
    var fields = Array.isArray(_this4.props.dataField) ? _this4.props.dataField : [_this4.props.dataField];
    var parsedSuggestions = (0, _suggestions2.default)(fields, results, _this4.state.currentValue.toLowerCase());

    if (renderSuggestion) {
      return parsedSuggestions.map(function (suggestion) {
        return renderSuggestion(suggestion);
      });
    }

    return parsedSuggestions;
  };

  this.setValue = function (value) {
    var isDefaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this4.props;
    var cause = arguments[3];
    var hasMounted = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true; // ignore state updates when component is locked

    if (props.beforeValueChange && _this4.locked) {
      return;
    }

    _this4.locked = true;

    var performUpdate = function performUpdate() {
      if (hasMounted) {
        _this4.setState({
          currentValue: value,
          suggestions: []
        }, function () {
          if (isDefaultValue) {
            if (_this4.props.autosuggest) {
              _this4.setState({
                isOpen: false
              });

              _this4.updateQuery(_this4.internalComponent, value, props);
            } // in case of strict selection only SUGGESTION_SELECT should be able
            // to set the query otherwise the value should reset


            if (props.strictSelection) {
              if (cause === _causes2.default.SUGGESTION_SELECT || value === '') {
                _this4.updateQuery(props.componentId, value, props);
              } else {
                _this4.setValue('', true);
              }
            } else {
              _this4.updateQuery(props.componentId, value, props);
            }
          } else {
            // debounce for handling text while typing
            _this4.handleTextChange(value);
          }

          _this4.locked = false;
          if (props.onValueChange) props.onValueChange(value);
        });
      } else {
        if (_this4.props.autosuggest) {
          _this4.updateQuery(_this4.internalComponent, value, props);
        }

        _this4.updateQuery(props.componentId, value, props);

        _this4.locked = false;
        if (props.onValueChange) props.onValueChange(value);
      }
    };

    (0, _helper.checkValueChange)(props.componentId, value, props.beforeValueChange, performUpdate);
  };

  this.handleTextChange = (0, _helper.debounce)(function (value) {
    if (_this4.props.autosuggest) {
      _this4.updateQuery(_this4.internalComponent, value, _this4.props);
    } else {
      _this4.updateQuery(_this4.props.componentId, value, _this4.props);
    }
  }, this.props.debounce);

  this.updateQuery = function (componentId, value, props) {
    var customQuery = props.customQuery,
        filterLabel = props.filterLabel,
        showFilter = props.showFilter,
        URLParams = props.URLParams;
    var customQueryOptions = void 0;
    var defaultQueryTobeSet = DataSearch.defaultQuery(value, props);
    var query = defaultQueryTobeSet;

    if (customQuery) {
      var customQueryTobeSet = customQuery(value, props);
      var queryTobeSet = customQueryTobeSet.query;

      if (queryTobeSet) {
        query = [queryTobeSet];
      }

      customQueryOptions = (0, _helper.getOptionsFromQuery)(customQueryTobeSet);
    } // query options should be applied to the source component,
    // not on internal component, hence using `this.props.componentId` here


    props.setQueryOptions(_this4.props.componentId, _extends({}, _this4.queryOptions, customQueryOptions));
    props.updateQuery({
      componentId: componentId,
      query: query,
      value: value,
      label: filterLabel,
      showFilter: showFilter,
      URLParams: URLParams,
      componentType: 'DATASEARCH'
    });
  };

  this.handleFocus = function (event) {
    _this4.setState({
      isOpen: true
    });

    if (_this4.props.onFocus) {
      _this4.props.onFocus(event);
    }
  };

  this.clearValue = function () {
    _this4.setValue('', true);

    _this4.onValueSelected(null, _causes2.default.CLEAR_VALUE);
  };

  this.handleKeyDown = function (event, highlightedIndex) {
    // if a suggestion was selected, delegate the handling
    // to suggestion handler
    if (event.key === 'Enter' && highlightedIndex === null) {
      _this4.setValue(event.target.value, true);

      _this4.onValueSelected(event.target.value, _causes2.default.ENTER_PRESS);
    }

    if (_this4.props.onKeyDown) {
      _this4.props.onKeyDown(event);
    }
  };

  this.onInputChange = function (e) {
    var inputValue = e.target.value;

    if (!_this4.state.isOpen) {
      _this4.setState({
        isOpen: true
      });
    }

    var _props3 = _this4.props,
        value = _props3.value,
        onChange = _props3.onChange;

    if (value === undefined) {
      _this4.setValue(inputValue);
    } else if (onChange) {
      onChange(inputValue);
    }
  };

  this.onSuggestionSelected = function (suggestion) {
    var _props4 = _this4.props,
        value = _props4.value,
        onChange = _props4.onChange;

    if (value === undefined) {
      _this4.setValue(suggestion.value, true, _this4.props, _causes2.default.SUGGESTION_SELECT);
    } else if (onChange) {
      onChange(suggestion.value);
    } // onValueSelected is user interaction driven:
    // it should be triggered irrespective of controlled (or)
    // uncontrolled component behavior


    _this4.onValueSelected(suggestion.value, _causes2.default.SUGGESTION_SELECT, suggestion.source);
  };

  this.onValueSelected = function () {
    for (var _len = arguments.length, cause = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      cause[_key - 1] = arguments[_key];
    }

    var currentValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this4.state.currentValue;
    var onValueSelected = _this4.props.onValueSelected;

    if (onValueSelected) {
      onValueSelected.apply(undefined, [currentValue].concat(cause));
    }
  };

  this.handleStateChange = function (changes) {
    var isOpen = changes.isOpen,
        type = changes.type;

    if (type === _downshift2.default.stateChangeTypes.mouseUp) {
      _this4.setState({
        isOpen: isOpen
      });
    }
  };

  this.getBackgroundColor = function (highlightedIndex, index) {
    var isDark = _this4.props.themePreset === 'dark';

    if (isDark) {
      return highlightedIndex === index ? '#555' : '#424242';
    }

    return highlightedIndex === index ? '#eee' : '#fff';
  };

  this.handleSearchIconClick = function () {
    var currentValue = _this4.state.currentValue;

    if (currentValue.trim()) {
      _this4.setValue(currentValue, true);
    }
  };

  this.renderIcon = function () {
    if (_this4.props.showIcon) {
      return _this4.props.icon || _react2.default.createElement(_SearchSvg2.default, null);
    }

    return null;
  };

  this.renderCancelIcon = function () {
    if (_this4.props.showClear) {
      return _this4.props.clearIcon || _react2.default.createElement(_CancelSvg2.default, null);
    }

    return null;
  };

  this.renderIcons = function () {
    return _react2.default.createElement('div', null, _this4.state.currentValue && _this4.props.showClear && _react2.default.createElement(_InputIcon2.default, {
      onClick: _this4.clearValue,
      iconPosition: 'right',
      clearIcon: _this4.props.iconPosition === 'right'
    }, _this4.renderCancelIcon()), _react2.default.createElement(_InputIcon2.default, {
      onClick: _this4.handleSearchIconClick,
      iconPosition: _this4.props.iconPosition
    }, _this4.renderIcon()));
  };

  this.renderNoSuggestion = function () {
    var finalSuggestionsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var _props5 = _this4.props,
        themePreset = _props5.themePreset,
        theme = _props5.theme,
        isLoading = _props5.isLoading,
        renderNoSuggestion = _props5.renderNoSuggestion,
        innerClass = _props5.innerClass,
        error = _props5.error,
        renderError = _props5.renderError;
    var _state = _this4.state,
        isOpen = _state.isOpen,
        currentValue = _state.currentValue;

    if (renderNoSuggestion && isOpen && !finalSuggestionsList.length && !isLoading && currentValue && !(renderError && error)) {
      return _react2.default.createElement(_SuggestionWrapper2.default, {
        innerClass: innerClass,
        themePreset: themePreset,
        theme: theme,
        innerClassName: 'noSuggestion'
      }, typeof renderNoSuggestion === 'function' ? renderNoSuggestion(currentValue) : renderNoSuggestion);
    }

    return null;
  };

  this.renderLoader = function () {
    var _props6 = _this4.props,
        loader = _props6.loader,
        isLoading = _props6.isLoading,
        themePreset = _props6.themePreset,
        theme = _props6.theme,
        innerClass = _props6.innerClass;
    var currentValue = _this4.state.currentValue;

    if (isLoading && loader && currentValue) {
      return _react2.default.createElement(_SuggestionWrapper2.default, {
        innerClass: innerClass,
        innerClassName: 'loader',
        theme: theme,
        themePreset: themePreset
      }, loader);
    }

    return null;
  };

  this.renderError = function () {
    var _props7 = _this4.props,
        error = _props7.error,
        renderError = _props7.renderError,
        themePreset = _props7.themePreset,
        theme = _props7.theme,
        isLoading = _props7.isLoading,
        innerClass = _props7.innerClass;
    var currentValue = _this4.state.currentValue;

    if (error && renderError && currentValue && !isLoading) {
      return _react2.default.createElement(_SuggestionWrapper2.default, {
        innerClass: innerClass,
        innerClassName: 'error',
        theme: theme,
        themePreset: themePreset
      }, (0, _utils.isFunction)(renderError) ? renderError(error) : renderError);
    }

    return null;
  };
};

DataSearch.propTypes = {
  addComponent: _types2.default.funcRequired,
  removeComponent: _types2.default.funcRequired,
  setQueryListener: _types2.default.funcRequired,
  setQueryOptions: _types2.default.funcRequired,
  updateQuery: _types2.default.funcRequired,
  watchComponent: _types2.default.funcRequired,
  options: _types2.default.options,
  selectedValue: _types2.default.selectedValue,
  suggestions: _types2.default.suggestions,
  // component props
  autoFocus: _types2.default.bool,
  autosuggest: _types2.default.bool,
  beforeValueChange: _types2.default.func,
  className: _types2.default.string,
  clearIcon: _types2.default.children,
  componentId: _types2.default.stringRequired,
  customHighlight: _types2.default.func,
  customQuery: _types2.default.func,
  dataField: _types2.default.dataFieldArray,
  debounce: _types2.default.number,
  defaultValue: _types2.default.string,
  value: _types2.default.string,
  defaultSuggestions: _types2.default.suggestions,
  downShiftProps: _types2.default.props,
  // eslint-disable-next-line
  error: _types2.default.any,
  fieldWeights: _types2.default.fieldWeights,
  filterLabel: _types2.default.string,
  fuzziness: _types2.default.fuzziness,
  highlight: _types2.default.bool,
  highlightField: _types2.default.stringOrArray,
  icon: _types2.default.children,
  iconPosition: _types2.default.iconPosition,
  innerClass: _types2.default.style,
  isLoading: _types2.default.bool,
  loader: _types2.default.title,
  nestedField: _types2.default.string,
  onError: _types2.default.func,
  onBlur: _types2.default.func,
  onFocus: _types2.default.func,
  onKeyDown: _types2.default.func,
  onKeyPress: _types2.default.func,
  onKeyUp: _types2.default.func,
  onQueryChange: _types2.default.func,
  onSuggestions: _types2.default.func,
  onValueChange: _types2.default.func,
  onChange: _types2.default.func,
  onValueSelected: _types2.default.func,
  placeholder: _types2.default.string,
  queryFormat: _types2.default.queryFormatSearch,
  react: _types2.default.react,
  renderError: _types2.default.title,
  renderSuggestion: _types2.default.func,
  renderAllSuggestions: _types2.default.func,
  renderNoSuggestion: _types2.default.title,
  showClear: _types2.default.bool,
  showFilter: _types2.default.bool,
  showIcon: _types2.default.bool,
  style: _types2.default.style,
  title: _types2.default.title,
  theme: _types2.default.style,
  themePreset: _types2.default.themePreset,
  URLParams: _types2.default.bool,
  strictSelection: _types2.default.bool
};
DataSearch.defaultProps = {
  autosuggest: true,
  className: null,
  debounce: 0,
  downShiftProps: {},
  iconPosition: 'left',
  placeholder: 'Search',
  queryFormat: 'or',
  showFilter: true,
  showIcon: true,
  style: {},
  URLParams: false,
  showClear: false,
  strictSelection: false
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    selectedValue: state.selectedValues[props.componentId] && state.selectedValues[props.componentId].value || null,
    suggestions: state.hits[props.componentId] && state.hits[props.componentId].hits,
    themePreset: state.config.themePreset,
    isLoading: state.isLoading[props.componentId],
    error: state.error[props.componentId]
  };
};

var mapDispatchtoProps = function mapDispatchtoProps(dispatch) {
  return {
    addComponent: function addComponent(component) {
      return dispatch((0, _actions.addComponent)(component));
    },
    removeComponent: function removeComponent(component) {
      return dispatch((0, _actions.removeComponent)(component));
    },
    setQueryOptions: function setQueryOptions(component, props) {
      return dispatch((0, _actions.setQueryOptions)(component, props));
    },
    updateQuery: function updateQuery(updateQueryObject) {
      return dispatch((0, _actions.updateQuery)(updateQueryObject));
    },
    watchComponent: function watchComponent(component, react) {
      return dispatch((0, _actions.watchComponent)(component, react));
    },
    setQueryListener: function setQueryListener(component, onQueryChange, beforeQueryChange) {
      return dispatch((0, _actions.setQueryListener)(component, onQueryChange, beforeQueryChange));
    }
  };
};

var ConnectedComponent = (0, _utils.connect)(mapStateToProps, mapDispatchtoProps)((0, _emotionTheming.withTheme)(function (props) {
  return _react2.default.createElement(DataSearch, _extends({
    ref: props.myForwardedRef
  }, props));
})); // eslint-disable-next-line

var ForwardRefComponent = _react2.default.forwardRef(function (props, ref) {
  return _react2.default.createElement(ConnectedComponent, _extends({}, props, {
    myForwardedRef: ref
  }));
});

(0, _hoistNonReactStatics2.default)(ForwardRefComponent, DataSearch);
ForwardRefComponent.name = 'DataSearch';
exports.default = ForwardRefComponent;